<!-- PROGRESS BAR -->
<meta name="viewport" content="initial-scale=1, maximum-scale=1, user-scalable=no, width=device-width" />

<div class="app-container" [attr.data-theme]="currentTheme">
    <ng-container *ngIf="innerWidth && !inAuthPages; else unauthenticatedViews">
        <!-- Elements to display for logged-in users -->
        <fuse-progress-bar></fuse-progress-bar>
        <aep-layout></aep-layout>
        <!-- 
        <small-layout *ngIf="innerWidth < 769"></small-layout> -->
    </ng-container>

    <ng-template #unauthenticatedViews>
        <!-- Elements to display for unauthenticated users -->
        <div class="auth-view">
            <router-outlet></router-outlet>
        </div>
    </ng-template>
</div>